import { useMutation } from '@tanstack/react-query';
import { advisorAdminApi } from '../api/api';

export function useAdvisorSearch() {
  const mutation = useMutation({
    mutationFn: (query: string) => {
      const trimmed = query.trim();
      const isEmail = trimmed.includes('@');
      return advisorAdminApi.searchAdvisor(
        isEmail ? { advisorEmail: trimmed } : { advisorId: trimmed },
      );
    },
  });

  return {
    searchAdvisor: mutation.mutate,
    advisor: mutation.data?.advisor ?? null,
    clientCount: mutation.data?.clientCount ?? 0,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
